import { render } from "./AddNewPatientOverlay.vue?vue&type=template&id=2f686920&scoped=true&lang=pug"
import script from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"

import "./AddNewPatientOverlay.vue?vue&type=style&index=0&id=2f686920&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f686920"]])

export default __exports__